import { TravelHero } from './TravelHero';

export default TravelHero;
